import { useGSAP } from '@gsap/react';
import { gsap } from 'gsap';
import type { RefObject } from 'react';

/**
 * Temps forts de l'interface pendant la traversée, sur une échelle de 0 à 1
 * alignée sur le défilement, donc sur l'avancée du film.
 */
const BEATS = [
  { enter: 0.13, exit: 0.29 },
  { enter: 0.37, exit: 0.53 },
  { enter: 0.61, exit: 0.77 },
] as const;
const FADE = 0.05;

/**
 * Fait apparaître les textes superposés au fil de la traversée. Le décor lit
 * lui-même l'avancée de la section : les deux restent alignés sur le défilement.
 */
export function useJourneyChoreography(
  section: RefObject<HTMLElement | null>,
  enabled: boolean,
): void {
  useGSAP(
    () => {
      const root = section.current;
      if (!enabled || !root) return;

      const intro = root.querySelector('[data-journey="intro"]');
      const beats = gsap.utils.toArray<HTMLElement>('[data-journey="beat"]', root);

      const timeline = gsap.timeline({
        defaults: { ease: 'none' },
        scrollTrigger: {
          trigger: root,
          start: 'top top',
          end: 'bottom bottom',
          scrub: 0.5,
          onUpdate: (self) => {
            root.style.setProperty('--journey-progress', self.progress.toFixed(4));
          },
        },
      });

      // Échelle fixe de 0 à 1, quelle que soit la hauteur de la section.
      timeline.set({}, {}, 1);
      timeline.to(intro, { autoAlpha: 0, y: -80, duration: 0.1 }, 0.01);

      beats.forEach((beat, index) => {
        const timing = BEATS[index];
        if (!timing) return;
        timeline
          .fromTo(
            beat,
            { autoAlpha: 0, scale: 0.94 },
            { autoAlpha: 1, scale: 1, duration: FADE },
            timing.enter,
          )
          .to(beat, { autoAlpha: 0, scale: 1.06, duration: FADE }, timing.exit - FADE);
      });
    },
    { scope: section, dependencies: [enabled] },
  );
}
